// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1fU5u","buttons":"PendingPaymentAlert_buttons__3wZxR"};